export const EDITOR_MACRO_ADF_RENDERING =
	'confluence.frontend.fabric.editor.macro.adf.frontend.render';
export const EDITOR_ENABLE_AI_UPSELL = 'platform.ai.enable-ai-upsell';
